import styled from "styled-components";
import {
  colors,
  spacing,
  typography,
} from "../../../../../styles/theme";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: ${spacing("2")};
`;

export const TableHeader = styled.th`
  padding: ${spacing("2")};
  text-align: left;
  font-size: ${typography("fontSize")};
  color: ${colors("neutral")};
  border-bottom: 2px solid ${colors("default.base")};

  &:first-child {
    width: 40%;
  }

  &:nth-child(2), &:nth-child(3) {
    width: 20%;
    text-align: center;
  }

  &:last-child {
    width: 20%;
    text-align: center;
  }
`;